import * as ActionTypes from './types';

const fetchLatestBptReport = (id) => ({
  [ActionTypes.API_CALL]: {
    method: 'GET',
    types: [
      ActionTypes.FETCH_BPT_HEALTH_REPORT_REQUEST,
      ActionTypes.FETCH_BPT_HEALTH_REPORT_SUCCESS,
      ActionTypes.FETCH_BPT_HEALTH_REPORT_FAILURE,
    ],
    endpoint: `/api/terminals/health/${id}`,
  },
});

const loadLatestBptReport = (id) => (dispatch) => dispatch(fetchLatestBptReport(id));

export default loadLatestBptReport;
